/**
 * @generated SignedSource<<ee723c954c9dd6d7cd50aa0d01972a5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProjectUnlockTimeSheetMutation$variables = {
  id: number;
};
export type ProjectUnlockTimeSheetMutation$data = {
  readonly unlockProjectTimeSheet: {
    readonly project: {
      readonly id: number;
      readonly timesheet_lock_status: any | null | undefined;
      readonly timesheet_lock_status_updated_at: string | null | undefined;
      readonly timesheet_locked_to: any | null | undefined;
    } | null | undefined;
  };
};
export type ProjectUnlockTimeSheetMutation = {
  response: ProjectUnlockTimeSheetMutation$data;
  variables: ProjectUnlockTimeSheetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ProjectResult",
    "kind": "LinkedField",
    "name": "unlockProjectTimeSheet",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "projects",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timesheet_lock_status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timesheet_locked_to",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timesheet_lock_status_updated_at",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectUnlockTimeSheetMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectUnlockTimeSheetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "77fbfee2eaf1299c228c4c455002dbb5",
    "id": null,
    "metadata": {},
    "name": "ProjectUnlockTimeSheetMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectUnlockTimeSheetMutation(\n  $id: Int!\n) {\n  unlockProjectTimeSheet(id: $id) {\n    project {\n      id\n      timesheet_lock_status\n      timesheet_locked_to\n      timesheet_lock_status_updated_at\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ebad2860befd3c00caa66fc600a476c0";

export default node;
